import {computed} from 'vue';
import {useLocale} from '#imports';
import {useFeatureFlag} from '@malt/feature-flags';

const NEW_UNLOGGED_NAVBAR_FLAG = 'new-unlogged-navbar' as const;
const NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG = 'new-unlogged-navbar-malt-com' as const;
const NAVBAR_TRANSPARENT_MODE_FLAG = 'navbar-transparent-mode' as const;
const NAVBAR_TRANSPARENT_MODE_MALT_COM_FLAG = 'navbar-transparent-mode-malt-com' as const;

function useHostScopedFeatureFlag(localeFlag: Parameters<typeof useFeatureFlag>[0], maltComFlag: Parameters<typeof useFeatureFlag>[0]) {
    const {isMultiLocaleHost} = useLocale();
    const localeEnabled = useFeatureFlag(localeFlag);
    const maltComEnabled = useFeatureFlag(maltComFlag);

    return computed(() => (isMultiLocaleHost.value ? maltComEnabled.value : localeEnabled.value));
}

export function useNewUnloggedNavbar() {
    return useHostScopedFeatureFlag(NEW_UNLOGGED_NAVBAR_FLAG, NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG);
}

export function useNavbarTransparentMode() {
    return useHostScopedFeatureFlag(NAVBAR_TRANSPARENT_MODE_FLAG, NAVBAR_TRANSPARENT_MODE_MALT_COM_FLAG);
}
